import {
  CollegeGraduationYear,
  StudentAddressZipcode,
  StudentPhoneNumber,
  TCPAConsent,
} from "@up/application-fields";

import type { ReactNode } from "react";

export function StudentInformationPage2Adult({
  bottom,
  userData,
}: {
  bottom: () => ReactNode;
  userData: any;
}) {
  return (
    <>
      {userData["student-mailing-address-country"] === "United States" ? (
        <div className="grid-cols-2 gap-4 md:grid">
          <StudentAddressZipcode />
        </div>
      ) : null}

      <CollegeGraduationYear label="College Graduation Year" />

      <StudentPhoneNumber label="Mobile Phone Number" />

      <TCPAConsent />

      {bottom()}
    </>
  );
}
